import { put, takeLatest, call, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import checkoutAPI from '../../api/checkout';
import { Types, Creators as CreditCardCreators } from '../../reducers/creditCard';
import getState from '../../utils/getState';

function* validateCreditCard({ data }) {
  try {
    const { creditCard, app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);
    let { flag } = creditCard.creditCard;
    let numero = data;

    if (data && (data.length === 4 || data.length === 8 || data.length > 12)) {
      const result = yield call(checkoutAPI.validateCreditCard, data, siteId);

      if (result) {
        numero = result.numero || data;
        flag = result.bandeira && result.bandeira.key ? `${result.bandeira.key}`.toLowerCase() : '';
      }
    }

    if (data && data.length < 5) {
      flag = '';
    }

    yield put(
      CreditCardCreators.validateCreditCardSuccess({
        ...creditCard.getIn(['creditCard']),
        flag,
        numero,
        isLoading: false,
        updateAt: new Date().getTime(),
      })
    );
  } catch (error) {
    yield put(CreditCardCreators.validateCreditCardError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.VALIDATE_CREDIT_CARD_REQUEST, validateCreditCard);
}
